<template>
  <main-content>
    <transacions :changeStatus="changeStatus"></transacions>
    <Empty v-if="status == 'loading'"></Empty>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import transacions from "@/pages/transactions/transacions";
import Empty from "@/pages/transactions/transacions_empty"
export default {
  name: "Get",
  data() {
    return {
      status: 'loading'
    }
  },
  components: {MainContent, transacions,Empty},
  methods: {
    changeStatus(status) {
      this.status = status
    }
  }
}
</script>

<style scoped>

</style>